import React, { useEffect, useLayoutEffect, useMemo, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import ReactHtmlParser from 'react-html-parser';
import ModalDrawer from '@stone/components/modal/ModalDrawer';
import customEventBus from '@common/scripts/libs/eventBus';
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs';
import Image from '@stone/ui/image/Image';
const EVENTNAME = 'instalmentDrawer';
const requestInstalmentDrawerOpen = (e) => {
    customEventBus.emit(EVENTNAME + ':toggle', {
        action: 'open',
        originalEvent: e,
    });
};
export const InstalmentButton = () => {
    const { t } = useTranslation();
    const [showButton, setShowButton] = useState(window.hasEditorialInstalment);
    useLayoutEffect(() => {
        let handler = (data) => {
            setShowButton(!(data === null || data === void 0 ? void 0 : data.distroy));
        };
        customEventBus.on(EVENTNAME + ':init', handler);
        return () => {
            customEventBus.off(EVENTNAME + ':init', handler);
        };
    }, []);
    return ((showButton && (React.createElement("button", { "aria-haspopup": "dialog", onClick: (e) => {
            requestInstalmentDrawerOpen(e);
        }, className: "button button--link-underline text-left" }, t('instalmentpayment.pdpdrawer.cta')))) || React.createElement(React.Fragment, null));
};
const ProductInstalmentDrawer = (props) => {
    const { t } = useTranslation();
    const [isOpen, setIsOpen] = useState(props.isOpen);
    const openerElement = useRef(null);
    // * MEMO ----------------------------------------------------------------------------------------------------------------------------------------
    const tabComponetns = useMemo(() => {
        var _a;
        return (_a = props.componentsDrawer) === null || _a === void 0 ? void 0 : _a.components;
    }, [props.componentsDrawer]);
    // * EFFECTS ----------------------------------------------------------------------------------------------------------------------------------------
    useEffect(() => {
        let handler = (data) => {
            var _a;
            if (data.action == 'open') {
                openerElement.current = (_a = data.originalEvent) === null || _a === void 0 ? void 0 : _a.target;
                setIsOpen(data.target || true);
            }
            else {
                setIsOpen(false);
            }
        };
        customEventBus.on(EVENTNAME + ':toggle', handler);
        return () => {
            customEventBus.off(EVENTNAME + ':toggle', handler);
        };
    }, []);
    useLayoutEffect(() => {
        customEventBus.emit(EVENTNAME + ':init', {});
        return () => {
            customEventBus.emit(EVENTNAME + ':init', { destroy: true });
        };
    }, [tabComponetns]);
    // * FUNCTIONS ----------------------------------------------------------------------------------------------------------------------------------------
    const handleClose = () => {
        props.handleClose && props.handleClose();
        setIsOpen(false);
        setTimeout(() => {
            var _a;
            (_a = openerElement.current) === null || _a === void 0 ? void 0 : _a.focus();
        }, 0);
    };
    if (!(props === null || props === void 0 ? void 0 : props.product))
        return React.createElement(React.Fragment, null);
    return (React.createElement(ModalDrawer, { isOpen: !!isOpen, onRequestClose: handleClose, contentLabel: t('instalmentpayment.pdpdrawer.title'), id: "product-instarlment-modal" }, (tabComponetns === null || tabComponetns === void 0 ? void 0 : tabComponetns.length) && (React.createElement(Tabs, { className: "tabs tabs-stilized-hide mt-60" },
        React.createElement(TabList, { className: "react-tabs__tab-list" }, tabComponetns.map((com, _i) => (React.createElement(Tab, { key: com.ID }, com.tabname)))),
        React.createElement("div", { className: "mt-60" }, tabComponetns.map((com, _i) => {
            var _a;
            return (React.createElement(TabPanel, { key: com.ID, forceRender: true },
                com.logo && React.createElement(Image, { src: (_a = com.logo) === null || _a === void 0 ? void 0 : _a.path, alt: "" }),
                com.content && React.createElement("div", { className: "mt-12" }, ReactHtmlParser(com.content)),
                com.link && com.linktext && (React.createElement("div", { className: "mt-40" },
                    React.createElement("a", { href: com.link, target: "_blank", className: "button button--cta" },
                        React.createElement("span", null, com.linktext))))));
        }))))));
};
export default ProductInstalmentDrawer;
